import React from "react"
import { AnimatePresence } from "framer-motion"
// Web Fonts
import "@fontsource-variable/montserrat"
import "@fontsource-variable/manrope"
// Global Stylesheet
import "./src/styles/global.css"

// export function onClientEntry() {
//   return window.addEventListener("load", () => {
//     document.body.className = document.body.className.replace(/\bno-js\b/, "")
//   })
// }

export const wrapPageElement = ({ element }) => (
	<AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
)

export const shouldUpdateScroll = ({
	routerProps: { location },
	getSavedScrollPosition,
}) => {
	// transition duration from `layout.js` * 1000 to get time in ms
	// * 2 for exit + enter animation
	const TRANSITION_DELAY = 250
	// if it's a "normal" route
	if (location.action === "PUSH") {
		window.setTimeout(() => window.scrollTo(0, 0), TRANSITION_DELAY)
	}
	// if we used the browser's forwards or back button
	else {
		const savedPosition = getSavedScrollPosition(location) || [0, 0]
		window.setTimeout(() => window.scrollTo(...savedPosition), TRANSITION_DELAY)
	}
	return false
}
